import React, { Fragment } from 'react';
import { StyleProp, View, ViewProps, ViewStyle } from 'react-native';

import { SeparatorHorizontal } from './SeparatorHorizontal';
import { SeparatorVertical } from './SeparatorVertical';
import { theme } from 'lib/theme';

type Props = {
  separator?: React.ReactNode | null;
  horizontal?: boolean;
  separatorColor?: string;
  separatorMargin?: number;
  separatorMarginOther?: number;
  separatorStyle?: StyleProp<ViewStyle>;
  marginHorizontal?: boolean;
};

export const ViewWithSeparators: React.FC<ViewProps & Props> = (props) => (
  <View
    {...props}
    style={[
      {
        flexDirection: props.horizontal ? 'row' : 'column',
      },
      props.marginHorizontal
        ? {
            marginLeft: theme.paddingHorizontal,
            marginRight: theme.paddingHorizontal,
          }
        : undefined,
      props.style,
    ]}
  >
    {React.Children.map(
      React.Children.toArray(props.children).filter((c) => !!c),
      (child, index) => (
        <Fragment key={index}>
          {index > 0 &&
            (props.separator === null
              ? null
              : props.separator ||
                (props.horizontal ? (
                  <SeparatorVertical
                    color={props.separatorColor}
                    marginHorizontal={props.separatorMargin}
                    marginVertical={props.separatorMarginOther}
                    style={[{ alignSelf: 'stretch' }, props.separatorStyle]}
                  />
                ) : (
                  <SeparatorHorizontal
                    color={props.separatorColor}
                    marginVertical={props.separatorMargin}
                    marginHorizontal={props.separatorMarginOther}
                    style={props.separatorStyle}
                  />
                )))}
          {child}
        </Fragment>
      ),
    )}
  </View>
);
